import { render, staticRenderFns } from "./CommissionUpdate.vue?vue&type=template&id=a6f6acc0&"
import script from "./CommissionUpdate.vue?vue&type=script&lang=js&"
export * from "./CommissionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports